import { useWatch } from 'react-hook-form'

import { ruleStates } from '../constants/misc'
import { useZodForm } from '../utils/use-zod-form'
import { loyaltyBonusRuleInputs } from './loyalty-bonus.schema'

import type { LoyaltyData } from './loyalty.schema'

function composePosId(id: string | null) {
  if (!id) return ''
  if (id.startsWith('MANUAL')) return 'Manual Sale'
  return `Trans. # ${id}`
}

const loyaltyQuerySelector = <T extends LoyaltyData>(data: T) => ({
  ...data,
  bonusRules: data.loyaltyRules.filter((rule) => rule.ruleType === 'bonus'),
  rewardRules: data.loyaltyRules.filter((rule) => rule.ruleType === 'reward'),
  returnedRules: data.loyaltyRules.filter(
    (rule) => rule.ruleType === 'returned reward'
  ),
})

function useCreateLoyaltyBonusForm(
  initialState: typeof ruleStates[number] = 'active'
) {
  const form = useZodForm({
    schema: loyaltyBonusRuleInputs,
    defaultValues: {
      type: 'dollar',
      value: 0,
      isManual: false,
      state: initialState,
      startDate: null,
      endDate: null,
      expirationPointsDays: null,
    },
  })
  const watchType = useWatch({ control: form.control, name: 'type' })

  return {
    watchType,
    ...form,
  }
}

export { composePosId, loyaltyQuerySelector, useCreateLoyaltyBonusForm }
